<template>
  <div class="live-reminder-box">
    <div class="row align-items-center">
      <div class="col-md-5">
        <div class="time-box">
          <span class="live-text mb-2">AO VIVO EM</span>
          <TextCountdown 
            class="countdown-text"
            :timestamp="liveReleasedTimestamp"
          />
        </div>
      </div>
      <div class="col-md-7">
        <div class="text-box">
          <LiveReminderSignUp></LiveReminderSignUp>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import TextCountdown from '@/components/layout/text/TextCountdown'
  import LiveReminderSignUp from './LiveReminderSignUp'

  export default {
    components: {
      TextCountdown,
      LiveReminderSignUp,
    },
    computed: {
      ...mapGetters('live', ['live']),
      liveReleasedTimestamp () {
        return (new Date(this.live.released_at)).getTime() / 1000
      }
    }
  }
</script>

<style scoped lang="scss">
  .live-reminder-box {
    padding: 20px;
    text-align: center;
    background-color: rgba(#fff, .05);
    border: 2px solid rgba(#fff, .5);
    border-radius: 5px;

    .countdown-text {
      font-size: 20px;
      font-weight: 600;
    }

    .live-text {
      font-weight: 300;
      font-size: 18px;
      color: #fff;
    }

    .text-box {
      padding-left: 30px;
      border-left: 1px solid rgba(#fff, .6);
    }

    @media (max-width: 768px) {
      .text-box {
        padding: 0;
        border: 0;
        padding-top: 20px;
        margin-top: 20px;
        border-top: 1px solid rgba(#fff, .6);
      }
    }
  }
</style>